import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { User } from 'Assistant/Chatbot/graphql/__generated__/User';
import { USER_QUERY } from 'Assistant/Chatbot';
import { AboutNova } from '../AboutNova';
import { AssistantIcon } from '../styles';
import { MessageText } from '../ChatbotMessage/styles';
import * as S from './styles';

function TransparencyMessage({
  handleAcknowledgeButtonPress,
}: {
  handleAcknowledgeButtonPress(): void;
}) {
  const { t: translate } = useTranslation('chatbot');
  const { data: userData } = useQuery<User>(USER_QUERY);

  return (
    <S.TransparencyMessageContainer>
      <S.AssistantIconContainer>
        <AssistantIcon aria-hidden={true} />
      </S.AssistantIconContainer>
      <S.TransparencyMessageTextContainer>
        <MessageText>
          {translate('conversation.transparency_message.text', {
            name: userData?.user?.firstName,
            context: !userData?.user?.firstName ? 'no_name' : '',
          })}
        </MessageText>
      </S.TransparencyMessageTextContainer>

      <S.NovaDisclaimerContainer>
        <AboutNova />
      </S.NovaDisclaimerContainer>
      <S.AcknowledgeButtonContainer>
        <S.AcknowledgeButton
          variant="primary"
          onClick={handleAcknowledgeButtonPress}
          aria-label={translate(
            'conversation.transparency_message.button_text',
          )}
          label={
            <S.AcknowledgeButtonText>
              {translate('conversation.transparency_message.button_text')}
            </S.AcknowledgeButtonText>
          }
        />
      </S.AcknowledgeButtonContainer>
    </S.TransparencyMessageContainer>
  );
}

export { TransparencyMessage };
